import { gql } from '@apollo/client';

/**
 * How the link flow learns what a multi-item Link session became. The browser
 * is handed no public token in such a session, so `useAccountLink` waits on
 * these instead: the subscription for latency, the query as the floor.
 */
export const PLAID_LINK_TOKEN_FRAGMENT = gql`
  fragment PlaidLinkTokenFields on PlaidLinkToken {
    id
    linkSessionId
    status
    results {
      outcome
      institutionName
      bankConnectionId
    }
  }
`;

export const PLAID_LINK_TOKEN = gql`
  query PlaidLinkToken($linkToken: String!) {
    plaidLinkToken(linkToken: $linkToken) {
      ...PlaidLinkTokenFields
    }
  }
  ${PLAID_LINK_TOKEN_FRAGMENT}
`;

export const PLAID_LINK_TOKEN_UPDATED = gql`
  subscription PlaidLinkTokenUpdated {
    plaidLinkTokenUpdated {
      ...PlaidLinkTokenFields
    }
  }
  ${PLAID_LINK_TOKEN_FRAGMENT}
`;
